import Vue from 'vue'
import Vuex from 'vuex'
import {
  Toast
} from 'mint-ui'
Vue.use(Vuex)
import {
  addScore,
  scoreUserInfo,
  isSign
} from "../common/js/common.js"
//console.log(addScore)
const store = new Vuex.Store({
  state: {
    // "openid":"",
    // "nickname":"",
    // "sex":1,
    // "province":"",
    // "city":"",
    // "country":"",
    // "headimgurl": "",
    // "privilege":[],
    // "unionid": ""
    localHistoryKeys: [],
    localContent: {},
    userInfo: {},
    hasSign: 0,
    loopSign: [],
    scoreUserInfo: {},
    islogged: false,
    globalAppId: 'wx45da7c657d626c93'

  },
  getters: {
    getLocalHistoryKeys: state => {
      if (localStorage.historyKeyStorage) {
        state.localHistoryKeys = localStorage.historyKeyStorage.split(",");
      }
      return state.localHistoryKeys
    },
    // getUserInfo (state)  {
    //   if(localStorage.getItem('userInfo')){
    //     state.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    //     state.userInfo.avatarUrl = state.userInfo.avatarUrl.replace("http:","https:")
    //   }
    //   return state.userInfo
    // },
    getLoopSign(state) {
      if (localStorage.getItem('loopSign')) {
        state.loopSign = localStorage.loopSign.split(',');
      }
      return state.loopSign;
    },


  },
  mutations: {
    changeLocalHistoryKeys(state, searchValue) { //把搜索关键词存到缓存里 搜索历史
      if (searchValue != "") {
        for (var i = 0; i < state.localHistoryKeys.length; i++) {
          if (searchValue == state.localHistoryKeys[i]) {
            state.localHistoryKeys.splice(i, 1);
          }
        }

        //在数组最前面加搜索词
        state.localHistoryKeys.unshift(searchValue)
        console.log(searchValue)
        localStorage.setItem("historyKeyStorage", state.localHistoryKeys);

        state.localHistoryKeys = localStorage.historyKeyStorage
        state.localHistoryKeys = state.localHistoryKeys.split(",")
        if (state.localHistoryKeys.length > 20) {
          state.localHistoryKeys.shift()
        }
      }
    },
    getLocalContent(state, localContent) {
      localStorage.localContent = JSON.stringify(localContent);
      state.localContent = localContent;
      //console.log(localStorage.localContent)
    },
    deleteLocalHistoryKeys(state) { //删除全部搜索关键词
      state.localHistoryKeys.splice(0, state.localHistoryKeys.length); //情况所有关键词
      localStorage.clear()
    },

    // getUserInfo (state)  {
    //   state.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    //
    //   //console.log(state.userInfo)
    //   //return state.userInfo
    // },

    //实现签到
    signIn(state) {

      //本地储存 签到时间
      //console.log(this.getters.getUserInfo)
      //localStorage.setItem("signedTime",signedTime)

      //console.log(!JSON.parse(state.hasSign))

      if (state.hasSign*1<1) {//
        // let signedTime = new Date().toLocaleDateString()
        // localStorage.setItem("signedTime",signedTime)
        //localStorage.setItem("hasSign",state.hasSign)
        //连续签到
        // if(localStorage.loopSign){
        //   state.loopSign = localStorage.loopSign.split(",");
        // }
        //state.loopSign.push(1)
        //console.log(state.loopSign)
        //localStorage.setItem('loopSign',state.loopSign)
        var that = this;
        this.state.hasSign = 1
        //localStorage.setItem('hasSign',state.hasSign)
        that.dispatch("cancelScore",{total:this.state.scoreUserInfo.totalScore*1,userScore:-3*1})
        addScore("签到", JSON.parse(sessionStorage.userInfo).openId, function(score) {
          Toast({
            message: "+" + score + "券币",
          })
           that.dispatch("cancelScore",{total:this.state.scoreUserInfo.totalScore*1,userScore:-score*1})

        })

      } else {
        Toast({
          message: '今天已签到，明天再来哦',
          duration: 5000
        })
      }
    },
    //获取积分值
    getScoreUserInfo(state) {

      //state.scoreUserInfo = scoreUserInfo(this.getters.getUserInfo.openId)

    },
    cancelScore(state, {//减去积分，可以用到签到，兑换上，但是加上积分 则用负数
      total,
      userScore
    }) {
      state.scoreUserInfo.totalScore = total * 1 - userScore * 1;
      console.log(total, userScore)
    }






  },
  actions: {
    changeLocalHistoryKeys(context, searchValue) {
      context.commit('changeLocalHistoryKeys', searchValue)
    },
    deleteLocalHistoryKeys(context) {
      context.commit('deleteLocalHistoryKeys')
    },
    getLocalContent(context, localContent) {
      context.commit('getLocalContent', localContent)
    },

    signIn(context) {
      context.commit('signIn')
    },
    getScoreUserInfo(context) {

        Vue.prototype.$ajax.autoService
          .login("api/getUserScoreInfo.php?openID=" + JSON.parse(sessionStorage.userInfo).openId).then((res) => {
            this.state.scoreUserInfo = res.data[0];
            console.log(this.state.scoreUserInfo)

          }, (res) => {
            console.log("失败")
          })
      context.commit('getScoreUserInfo')
    },
    hasSign(context) { //每次刷新获取是否签到
      Vue.prototype.$ajax.autoService.login('api/getEventInfo.php?eventName=签到')
        .then((res) => {
          event = res.data[0]
          Vue.prototype.$ajax.autoService
            .login('api/getCountsOneDay.php?eventID=' + event.eventID + '&openID=' + JSON.parse(sessionStorage.userInfo).openId).then((res => {

              this.state.hasSign = res.data
            }))
        })
     // let currentTime = new Date().toLocaleDateString();
     // if(currentTime != localStorage.signedTime ){
     //   localStorage.setItem('hasSign',0)
     // }

    },

    cancelScore(context, {
      total,
      userScore
    }) {
      context.commit("cancelScore", {
        total,
        userScore
      })
    }

  }
  //mutations: {
  // getUserfo (state) {
  //   axios.defaults.baseURL = ''
  //   this.url = "https://api.weixin.qq.com/sns/auth?access_token="+localStorage.ACCESS_TOKEN+"&openid="+localStorage.openid
  //   console.log(this.url )
  //   this.$ajax.autoService
  //       .login(this.url)
  //       .then((res) => {
  //         console.log(res)
  //       }, (res) => {
  //           console.log("error")
  //           this.REQUIRE = true;
  //       })
  // }
  //}
})

//实现自动登录




//获取现在时间

// console.log(currentTime,localStorage.signedTime)
// var loopSign ;


//
// if(currentTime != localStorage.signedTime ){
//   if(!JSON.parse(store.getters.getHasSign)||store.getters.getLoopSign.length >=7){//若有一天没签到，则重新签到
//     store.getters.getLoopSign.length = 0;
//     localStorage.setItem('loopSign',store.getters.getLoopSign)
//
//   }
//   store.dispatch('signInTimecompare');
// }
if (sessionStorage.islogged && JSON.parse(sessionStorage.islogged)) {
  store.dispatch('getScoreUserInfo')
  store.dispatch('hasSign')
}

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js